import React from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';

interface ResetFilterButtonProps {
  searchTerm: string;
  presetTerm?: string;
  setActiveFilters?: (filters: TagEntity[]) => void;
  section: string;
}

export const ResetFilterButton: React.FC<ResetFilterButtonProps> = ({
  searchTerm,
  presetTerm,
  setActiveFilters,
  section,
}) => {
  if (setActiveFilters) {
    return (
      <button
        className="button-hide-filters reset"
        onClick={() => setActiveFilters([])}
      >
        Nullstill filter
      </button>
    );
  }

  const link =
    searchTerm || presetTerm
      ? `/sok?phrase=indisk&size=36&section=${section}`
      : '/sok';

  return (
    <a className="button-hide-filters reset" href={link}>
      Nullstill filter
    </a>
  );
};
